const getDisplayNameFromUrl = (url?: string) => {
 if (!url) return 'Document'
 try {
  const pathname = new URL(url, window.location.origin)
   .pathname
  const raw = pathname.split('/').pop() || 'Document'
  return decodeURIComponent(raw).split('?')[0] || 'Document'
 } catch {
  const raw = url.split('/').pop() || 'Document'
  return decodeURIComponent(raw).split('?')[0] || 'Document'
 }
}

const formatFileSize = (bytes?: number) => {
 if (bytes === undefined || bytes === null || bytes <= 0) {
  return null
 }
 const kb = Math.max(1, Math.round(bytes / 1024))
 return `${kb} kb`
}

const isImageUrl = (url?: string) => {
 if (!url) return false
 return /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(url)
}

const isImageFileType = (fileType?: string, url?: string) =>
 fileType === 'image' || isImageUrl(url)

export {
 getDisplayNameFromUrl,
 formatFileSize,
 isImageUrl,
 isImageFileType,
}
